import store from "@/store"
import { CLEAR_ACCOUNT_ISLOADING, CLEAR_CONTACT_FORM_ISLOADING, CLEAR_PERSONAL_INFORMATION_ISLOADING, CLEAR_WAITLIST_ISLOADING } from "@/store/action_types"

export const resetLoaders = () => {
    store.dispatch(CLEAR_WAITLIST_ISLOADING)
    store.dispatch(CLEAR_ACCOUNT_ISLOADING)
    store.dispatch(CLEAR_PERSONAL_INFORMATION_ISLOADING)
    store.dispatch(CLEAR_CONTACT_FORM_ISLOADING)
}